export function isNullOrUndefined(value) {
  return value === null || value === undefined
}

export function isDefined(value) {
  return !isNullOrUndefined(value)
}
